<template>
<div>
  TESTEEEEEE
  {{loader}} --- {{items.length}}
  <div
    id="multiple"
    :class="`card card px-${space} py-${space} mt-${space} wrapper-multiples`"
    v-if="items.length > 0 && !loader"
  >
    <div>
      <button :class="isPanel ? 'font-size-title': ''" class="btn" style="box-shadow: none;" @click="visible = !visible">
        <i class="fas fa-check-circle"></i>
        {{ this.$t('reports.multiples.multiplesLabel') }}
      </button>
      <button
        class="btn pull-right"
        style="box-shadow: none;"
        @click="visible = !visible"
      >
        <i class="fas fa-angle-double-right" v-if="!visible"></i>
        <i v-else class="fas fa-angle-double-down"></i>
      </button>
    </div>
    <div class="wrapper-rankings card" v-if="loader">
      <div>
        <!-- <div class="loader d-flex justify-content-center align-items-center">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div> -->
        <b-table
          :fields="arrayFields"
          :items="[0, 1, 2, 3]"
          caption-bottom
          sort-icon-left
        >
          <template v-slot:cell(question)>
            <div>
              <idx-skeleton width="80" height="15" radius="10" />
            </div>
          </template>
          <template v-slot:cell(score)>
            <div class="text-right">
              <idx-skeleton width="25" height="15" radius="10" />
            </div>
          </template>
          <template v-slot:cell(total)>
            <div class="text-center">
              <idx-skeleton width="25" height="15" radius="10" />
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <div v-else>
      <b-collapse v-model="visible" class="mt-2">
        <b-table
          :id="isPanel ? 'size-panels' : ''"
          v-for="(item, i) in items"
          :key="i"
          responsive
          class="mt-4"
          :items="item.arrayItems"
          :fields="item.arrayFields"
          caption-bottom
          sort-icon-left
        >
          <template v-slot:cell(progress)="row">
            <div
              v-if="row.item.type !== 'total'"
              :style="isPanel ? 'width: 120px;' : ''"
              class="mt-2 text-left"
            >
              <b-progress :value="row.item.progress" :max="100"></b-progress>
            </div>
          </template>
          <template v-slot:cell(score)="row">
            <div v-if="row.item.type !== 'total'" class="text-left" :style="`font-size: ${fontSize}px;`">
              {{ row.item.score }}%
            </div>
          </template>
          <template v-slot:cell(total)="row">
            <div class="text-left" :style="`font-size: ${fontSize}px;`">
              {{ row.item.total }}
            </div>
          </template>
        </b-table>
        <div v-if="!isPanel" class="row">
          <div class="col-12 mt-2 text-right">
            <a
              @click="exportToXLS"
              :title="`${this.$t('reports.exportXlsLabel')}`"
            >
              <span class="xls">
                <i class="fas fa-file-download"></i>
              </span>
            </a>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
  <div v-if="!loader && items.length === 0">
      <span>Sem dados para exibir.</span>
    </div>
    <div v-if="loader">
      <b-table
          :fields="arrayFields"
          :items="[0, 1, 2, 3]"
          caption-bottom
          sort-icon-left
        >
          <template v-slot:cell(question)>
            <div>
              <idx-skeleton width="80" height="15" radius="10" />
            </div>
          </template>
          <template v-slot:cell(score)>
            <div class="text-right">
              <idx-skeleton width="25" height="15" radius="10" />
            </div>
          </template>
          <template v-slot:cell(total)>
            <div class="text-center">
              <idx-skeleton width="25" height="15" radius="10" />
            </div>
          </template>
      </b-table>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import XLSX from 'xlsx';
import EmptyState from '@/components/molecules/empty-state';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import api from '@/services/api';
import EventBus from '../../../../../../../eventBus';

export default {
  name: 'ScoreMultiples',

  props: ['showCollapsed', 'dataGraph'],

  components: {
    EmptyState,
    idxSkeleton,
  },

  data: () => ({
    isBusy: false,
    empty: false,
    filter: null,
    userAuth: null,
    visible: true,
    total: 0,
    totalAnswers: 0,
    page: 1,
    limit: 10,
    items: [],
    multiplesData: [],
    loader: false,
    fields: [],
    arrayFields: [],
    lang: 'br',
    space: 2,
    fontSize: 16,
  }),

  watch: {
    actionGroupData: function watchActionGroupData() {
      this.mountMultiples();
    },
    myActionId: function watchMyActionId() {
      this.mountMultiples();
    },
    myIh1: function watchMyIh1() {
      this.mountMultiples();
    },
    myIh2: function watchMyIh2() {
      this.mountMultiples();
    },
    calendarDates: function watchDates() {
      this.mountMultiples();
    },
    myMetric: function watchMyMetric() {
      this.mountMultiples();
    },
    'indicatorData.value': function watchMyMetric() {
      this.mountMultiples();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.mountMultiples();
    },
    '$i18n.locale': function watchLocale(value) {
      this.lang = value;
      this.mountMultiples();
    },
  },

  computed: {
    ...mapState('charts', ['filterRankings']),
    ...mapState('actions', ['myActionId', 'actionGroupData']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  methods: {
    async mountMultiples() {
      this.loader = true;
      const response = await api.get(`reports/multiples-panel`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: this.filterRankings ? this.filterRankings : null,
          companyId: this.userAuth.companyId,
          actionId: this.myActionId !== '0' ? this.myActionId : null,
          // startDate: this.calendarDates.start ? this.calendarDates.start : null,
          // endDate: this.calendarDates.end ? this.calendarDates.end : null,
          ih1: this.myIh1.map((item) => item._id),
          ih2: this.myIh2 === '0' ? null : this.myIh2,
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          lang: this.lang,
          period: data.period ? data.period : null,
          _id: this.dataGraph._id,


        },
      });
      this.multiplesData = response.data;
      this.items = [];
      this.totalAnswers = this.multiplesData.totalAnswers;

      const questions = [];
      let property;
      if (this.multiplesData) {
        // eslint-disable-next-line
        for (property in this.multiplesData) {
          const answers = this.getObjAnswers(this.multiplesData[property]);
          questions.push({ question: property, answers });
        }
      }
      // builds questions list correctly
      for (let i = 0; i < questions.length; i += 1) {
        for (let j = 0; j < questions[i].answers.length; j += 1) {
          if (questions[i].answers[j].option === 'total') {
            questions[i].total = questions[i].answers[j].qtd;
            questions[i].answers.splice(j, 1);
            break;
          }
        }
      }

      // builds items list
      this.items = [];
      for (let i = 0; i < questions.length; i += 1) {
        const arrayFields = [
          {
            key: 'question',
            label: questions[i].question,
            sortable: false,
            class: 'questionTh',
          },
          { key: 'progress', label: '', class: 'progressTh' },
          {
            key: 'score',
            label: this.$t('reports.multiples.scoreLabel'),
            sortable: true,
            class: 'scoreTh',
          },
          {
            key: 'total',
            label: this.$t('reports.multiples.totalLabel'),
            sortable: true,
            class: 'totalTh',
          },
        ];
        const arrayItems = [];
        for (let j = 0; j < questions[i].answers.length; j += 1) {
          arrayItems.push({
            question: questions[i].answers[j].text,
            progress: (
              (questions[i].answers[j].qtd / questions[i].total) *
              100
            ).toFixed(2),
            score: (
              (questions[i].answers[j].qtd / questions[i].total) *
              100
            ).toFixed(2),
            total: questions[i].answers[j].qtd,
            type: 'answer',
          });
        }
        arrayItems.push({
          question: this.$t('reports.multiples.totalAnswersLabel'),
          total: this.totalAnswers,
          type: 'total',
        });
        if (questions[i].answers.length > 0) {
          this.items.push({ arrayFields, arrayItems });
        }
      }

      this.loader = false;
    },

    getObjAnswers(obj) {
      const ansObj = [];
      // eslint-disable-next-line
      for (const property in obj) {
        ansObj.push({
          option: property,
          text: obj[property].text,
          qtd: property === 'total' ? obj[property] : obj[property].qtd,
        });
      }
      return ansObj;
    },

    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

    exportToXLS() {
      const header = [
        this.$t('reports.reviews.addQuestionLabel'),
        'Value',
        this.$t('reports.multiples.scoreLabel'),
        this.$t('reports.multiples.totalLabel'),
      ];

      const arr = [];

      for (let i = 0; i < this.items.length; i += 1) {
        const fields = this.items[i].arrayFields;
        const items = this.items[i].arrayItems;

        const field = fields[0].label;

        items.forEach((el) => {
          arr.push({
            [this.$t('reports.reviews.addQuestionLabel')]: field,
            Value: el.question,
            [this.$t('reports.multiples.scoreLabel')]: el.score,
            [this.$t('reports.multiples.totalLabel')]: el.total,
          });
        });
      }

      const wb = XLSX.utils.book_new();
      wb.SheetNames.push('rankings-multiples');

      const ws = XLSX.utils.json_to_sheet(arr, { header });
      wb.Sheets['rankings-multiples'] = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'rankings-multiples.xlsx');
      document.body.appendChild(link);
      link.click();
    },

    async mountCardPanel(data) {
      this.loader = true;
      alert('montooo')
      const response = await api.get(`reports/multiples-panel`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: this.filterRankings ? this.filterRankings : null,
          companyId: this.userAuth.companyId,
          actionId: data.actionId ? data.actionId._id : null,
          // startDate: '2022-01-01',
          // endDate: '2022-08-16',
          ih1: data.ih1 && data.ih1.length > 0 ? data.ih1.map((item) => item._id): null,
          ih2: null,
          period: data.period ? data.period : null,
          metric: data.metric ? data.metric : null,
          groupId: data.actionGroupId ? data.actionGroupId._id : null,
          indicator: data.indicator ? data.indicator : null,
          indicatorValue: data.valueIndicator ? data.valueIndicator : null,
          lang: this.lang,
          _id: this.dataGraph._id,
        },
      });
      this.multiplesData = response.data;
      this.items = [];

      const questions = [];
      let property;
      if (this.multiplesData) {
        // eslint-disable-next-line
        for (property in this.multiplesData) {
          const answers = this.getObjAnswers(this.multiplesData[property]);
          questions.push({ question: property, answers });
        }
      }
      // builds questions list correctly
      for (let i = 0; i < questions.length; i += 1) {
        for (let j = 0; j < questions[i].answers.length; j += 1) {
          if (questions[i].answers[j].option === 'total') {
            questions[i].total = questions[i].answers[j].qtd;
            questions[i].answers.splice(j, 1);
            break;
          }
        }
      }

      // builds items list
      this.items = [];
      for (let i = 0; i < questions.length; i += 1) {
        const arrayFields = [
          {
            key: 'question',
            label: questions[i].question,
            sortable: true,
            class: 'questionTh',
          },
          { key: 'progress', label: '', class: 'progressTh' },
          {
            key: 'score',
            label: this.$t('reports.multiples.scoreLabel'),
            sortable: true,
            class: 'scoreTh',
          },
          {
            key: 'total',
            label: this.$t('reports.multiples.totalLabel'),
            sortable: true,
            class: 'totalTh',
          },
        ];
        const arrayItems = [];
        for (let j = 0; j < questions[i].answers.length; j += 1) {
          arrayItems.push({
            question: questions[i].answers[j].option,
            progress: (
              (questions[i].answers[j].qtd / questions[i].total) *
              100
            ).toFixed(2),
            score: (
              (questions[i].answers[j].qtd / questions[i].total) *
              100
            ).toFixed(2),
            total: questions[i].answers[j].qtd,
            type: 'answer',
          });
        }
        arrayItems.push({
          question: this.$t('reports.multiples.totalAnswersLabel'),
          total: questions[i].total,
          type: 'total',
        });
        if (questions[i].answers.length > 0) {
          this.items.push({ arrayFields, arrayItems });
        }
      }

      this.loader = false;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  mounted() {
    this.visible = !this.showCollapsed;
    if (this.$route.fullPath.indexOf('panels') !== -1) {
      this.isPanel = true;
      this.mountCardPanel(this.dataGraph);

      EventBus.$on('update-multiple', (items) => {
        this.mountCardPanel(items);
      });

      this.score = 0;
      this.fontSize = 12;
    } else {
      this.lang = this.$i18n.locale;
      this.mountMultiples();
      EventBus.$on('filter-rankings', () => {
        this.mountMultiples();
      });
      this.score = 2;
    }

    this.arrayFields = [
      {
        key: 'question',
        label: this.$t('reports.emotion.addQuestionLabel'),
        sortable: true,
        class: 'questionTh',
      },
      { key: 'progress', label: '', class: 'progressTh' },
      {
        key: 'score',
        label: this.$t('reports.multiples.scoreLabel'),
        sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'total',
        label: this.$t('reports.multiples.totalLabel'),
        sortable: true,
        class: 'totalTh',
      },
    ];
  },
};
</script>

<style scoped lang="scss">
@import '@/themes/default/variables.scss';
.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-multiples .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-multiples .btn .btn-light .collapsed {
  background-color: transparent;
}
.wrapper-rankings.card {
  min-height: 200px;
}
.wrapper-rankings .loader {
  min-height: 200px;
}
.card {
  border: 1px solid #fff;
}
.card-panel {
  border: 1px solid #fff;
}
.hidden_header {
  display: none;
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;

  transition: color 0.2s;

  &:hover {
    color: #1dc86e;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/components/panels/multiples.vue